import React from 'react'

export default function EndAdd() {
    return (
        <div>
            <img className='endimg' src="./images/footer_banner.png" alt="..." />
        </div>
    )
}
